import React, {useContext, useEffect, useState} from 'react'

import emailLogo from 'assets/undraw_message_sent_1030.svg';
import {useStyles} from "./WaitingForEmailVerificationSection.css";
import {FirebaseAuthContext} from "../../firebase/FirebaseAuthProvider";
import Typography from "@mui/material/Typography";
import useSelfRegistration from "../registration/useSelfRegistration";
import {NavLink, Redirect} from "react-router-dom";
import {firebaseService} from "../../firebase/Firebase";
import {ArrowBackIos, ArrowForwardIos, Send} from "@mui/icons-material";
import AppButton from "../../elements/buttons/AppButton";
import {Link} from "@mui/material";
import {useIntl} from "react-intl";


const WaitingForEmailVerificationSection = () => {
    const classes = useStyles()
    const {signedInUser, signedInUserEmailVerified, signedInUserAuthCompleted} = useContext(FirebaseAuthContext)
    const {resendVerificationEmail, backToSignIn} = useSelfRegistration()
    const [showResend, setShowResend] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    useEffect(() => {
        firebaseService.auth().currentUser?.getIdToken(true);
    })

    /*
    If the user clicks on "enter the application", a token refresh will be forced and the user will be redirected
    to the auth gate again.
     */
    if (signedInUserAuthCompleted && signedInUserEmailVerified) {
        return <Redirect to={"/authorizedGate"}/>;
    }

    return (
        <div className={classes.root}>
            <Typography component="h1" variant="h5">
                {intl.formatMessage({
                    id: 'app.signUp.waitingForVerification.mailInfo',
                    defaultMessage: 'We sent an email to <code>{email}</code>.'
                }, {
                    email: signedInUser.email,
                    code: (component) => <b>{component}</b>
                })}
            </Typography>
            <img className={classes.image} src={emailLogo} alt='Email sent'/>
            <h2>
                {intl.formatMessage({
                    id: 'app.signUp.waitingForVerification.mailInboxInfo',
                    defaultMessage: 'Check your mail inbox and click on the confirmation link.'
                })}
            </h2>

            <div className={classes.buttonContainer}>
                <div>
                    <Link href='#' onClick={() => setShowResend(!showResend)}>
                        <Typography>
                            {intl.formatMessage({
                                id: 'app.signUp.waitingForVerification.resendQuestion',
                                defaultMessage: 'Didn\'t receive the mail?'
                            })}
                        </Typography>
                    </Link>
                    {
                        showResend && <div className={classes.buttonGroup}>
                            <AppButton
                                label={intl.formatMessage({
                                    id: 'app.signUp.waitingForVerification.resendLink.button',
                                    defaultMessage: 'Resend Verification Link'
                                })}
                                icon={<Send/>}
                                onClick={() => {
                                    resendVerificationEmail()
                                    setShowResend(false)
                                }
                                }/>
                        </div>
                    }
                </div>
                <div className={classes.buttonGroup}>
                    <AppButton
                        label={intl.formatMessage({
                            id: 'app.signUp.waitingForVerification.back.button',
                            defaultMessage: 'Back'
                        })}
                        icon={<ArrowBackIos/>}
                        onClick={backToSignIn}
                        variant="outlined"/>
                    <AppButton
                        label={intl.formatMessage({
                            id: 'app.signUp.waitingForVerification.enter.button',
                            defaultMessage: 'Enter'
                        })}
                        icon={<ArrowForwardIos/>}
                        component={NavLink}
                        to={'/waitingForEmailVerification'}/>
                </div>
            </div>
        </div>
    )
}

export default WaitingForEmailVerificationSection
